import React from 'react';
import { FaInstagram, FaLinkedin, FaTwitter, FaYoutube } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div>
      <footer className="bg-creamColor h-[38vh] w-full flex items-center justify-center">
        <div className="flex gap-7 text-3xl">
          <Link to="https://www.instagram.com/itsbooklore/" target="_blank">
            <FaInstagram className="hover:text-[#d62976] transition-all" />
          </Link>
          <Link to="https://www.youtube.com/@readatbooklore" target="_blank">
            <FaYoutube className="hover:text-red-500 transition-all" />
          </Link>
          <Link to="https://x.com/itsbooklore" target="_blank">
            <FaTwitter className="hover:text-blue-400 transition-all" />
          </Link>
          <Link to="https://www.linkedin.com/company/booklore-in/" target="_blank">
            <FaLinkedin className="hover:text-[#0077b5] transition-all" />
          </Link>

        </div>
      </footer>
    </div>
  );
};


export default Footer;
